import React from 'react';
import {Glyphicon, Clearfix} from 'react-bootstrap';
import PropTypes from 'prop-types';
import ArrowButton from '../../common/button-arrow';

const MessageFooter = ({
  toggleMessage, toggleReply, onDelete, open, reply, message
}) => (
  <div className="message-footer">
    <div className="pull-left delete-message" onClick={() => onDelete(message.id)}>
      <Glyphicon glyph="trash"/>
    </div>

    <ArrowButton
      submit={false}
      arrow={false}
      color="white"
      className="pull-right view-message"
      onClick={toggleMessage}
    >
      {open ? 'close' : 'view'}
    </ArrowButton>

    {reply && (
      <ArrowButton
        submit={false}
        arrow={false}
        color="white"
        className="pull-right reply-message"
        onClick={() => toggleReply(true, message)}
      >
        Reply
      </ArrowButton>
    )}

    <Clearfix/>
  </div>
);

MessageFooter.propTypes = {
  toggleMessage: PropTypes.func,
  toggleReply: PropTypes.func,
  onDelete: PropTypes.func,
  open: PropTypes.bool,
  message: PropTypes.object
};


export default MessageFooter;



// WEBPACK FOOTER //
// ./src/components/team/my-messages/message-footer.jsx